import { Button } from '@/ui/base/button';

interface PaginacaoCompactaProps {
  /** Página atual, base 1. */
  pagina: number;
  tamanho: number;
  total: number;
  aoMudar: (pagina: number) => void;
}

/**
 * Paginação para a lista em cartões do celular (`MobileCardList`): anterior,
 * posição e próxima, sem o seletor "Exibir" nem os botões numerados do
 * `DataPagination`, que não cabem em 375 px. A paginação continua no servidor
 * (CLAUDE.md, regras de API, item 6). Com uma página só, não aparece.
 */
export function PaginacaoCompacta({ pagina, tamanho, total, aoMudar }: PaginacaoCompactaProps) {
  const totalDePaginas = Math.max(1, Math.ceil(total / tamanho));
  if (totalDePaginas <= 1) return null;
  return (
    <nav
      aria-label="Paginação de resultados"
      className="mt-3 flex items-center justify-between gap-2 text-sm"
    >
      <Button
        type="button"
        size="sm"
        variant="outline"
        disabled={pagina <= 1}
        onClick={() => aoMudar(pagina - 1)}
      >
        Anterior
      </Button>
      <span role="status" aria-live="polite">
        Página {pagina} de {totalDePaginas}
      </span>
      <Button
        type="button"
        size="sm"
        variant="outline"
        disabled={pagina >= totalDePaginas}
        onClick={() => aoMudar(pagina + 1)}
      >
        Próxima
      </Button>
    </nav>
  );
}
